export default {
  module: {
    key: 'bbs/extra-hero',
    id: 'bbs-extra-hero',
    icon: 'fab fa-wexin',
  },
  setting: {
    bannerLink: 'bbs-extra-hero.bannerLink',
    tagSlug: 'bbs-extra-hero.tagSlug',
    sortType: 'bbs-extra-hero.sortType',
  },
};
